<!--Titre du right-pane - au complet () - plus bouton ajouter-->
<div class="main-page-toolbar">
  <h1 class="page-titre">
    <mat-icon>{{ IconGlobalPage }}</mat-icon
    >{{ TitreGlobalPage }}
  </h1>
</div>

<div class="main-page-container">
  <div class="listpage-container">
    <div class="listpage-header">
      <!-- CHAMPS RECHERCHE -->
      <div class="listpage-search-container">
        <mat-form-field appearance="outline">
          <mat-label>Date de commande</mat-label>
          <mat-date-range-input [rangePicker]="pickerRange">
            <input matStartDate placeholder="Date début" [(ngModel)]="recherche.OrderDate_DATE_FILTER_GE" name="OrderDate_DATE_FILTER_GE" />
            <input matEndDate placeholder="Date fin" [(ngModel)]="recherche.OrderDate_DATE_FILTER_LE" name="OrderDate_DATE_FILTER_LE" />
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="pickerRange"></mat-datepicker-toggle>
          <mat-date-range-picker #pickerRange></mat-date-range-picker>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Profile</mat-label>
          <mat-select [(ngModel)]="recherche.ProfileID" name="ProfileID">
            <mat-option [value]="">Tout</mat-option>
            <mat-option *ngFor="let profile of profiles" [value]="profile.ProfileID">{{ profile.name }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Site</mat-label>
          <mat-select [(ngModel)]="recherche.SiteID" name="SiteID">
            <mat-option [value]="">Tout</mat-option>
            <mat-option *ngFor="let site of sites" [value]="site.SiteID">{{ site.SiteName }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>SiteOrderID</mat-label>
          <input matInput [(ngModel)]="recherche.SiteOrderID" name="SiteOrderID" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Sku Produit</mat-label>
          <input matInput [(ngModel)]="recherche.sku_Cleaned" name="sku_Cleaned" />
        </mat-form-field>

        <mat-checkbox color="primary" [(ngModel)]="recherche.pretPourExpedition" name="pretPourExpedition">TAG Ready To Go</mat-checkbox>
      </div>

      <div class="recherche-btn-container">
        <button type="button" mat-stroked-button color="primary" (click)="effacerRecherche()"><mat-icon>delete</mat-icon> Effacer</button>
        <button type="button" mat-flat-button color="primary" (click)="rechercher()"><mat-icon>search</mat-icon> Rechercher</button>
        <button type="button" mat-flat-button color="warning" (click)="RefreshDVL()"><mat-icon>insights</mat-icon> Refresh DVL</button>
        <a mat-flat-button color="accent" style="cursor: pointer; align-self: baseline" (click)="exportexcel()"> <mat-icon>upload_file</mat-icon>Excel </a>
        <span class="pagination-count">{{ count ? count + " élément(s) trouvé(s)" : " " }}</span>
      </div>
    </div>
    <div class="listpage-body">
      <!-- LISTE -->

      <table
        id="myMainTable"
        class="table-liste table-liste-clickable"
        mat-table
        #table
        [dataSource]="dataSource"
        matSort
        matSortStart="desc"
        (matSortChange)="sortData($event)"
      >
        <ng-container matColumnDef="{{ champ['key'] }}" *ngFor="let champ of champs">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            [class.align-right]="champ['type'] == 'number' || champ['type'] == 'currency'"
            [class.align-center]="champ['type'] == 'boolean'"
          >
            {{ champ["nom"] }}
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            [class.align-right]="champ['type'] == 'number' || champ['type'] == 'currency'"
            [class.align-center]="champ['type'] == 'boolean'"
          >
            <span *ngIf="champ['type'] == 'string' || champ['type'] == 'number'">{{ row[champ["key"]] }}</span>
            <span *ngIf="champ['type'] == 'currency'">{{ row[champ["key"]] | currency }}</span>
            <span *ngIf="champ['type'] == 'date'">{{ row[champ["key"]] | formatDate : "D" }}</span>
            <span *ngIf="champ['type'] == 'boolean' && row[champ['key']] == true">
              <mat-icon>check</mat-icon>
            </span>
          </td>
        </ng-container>

        <!-- colonnes hardcodées -->
        <ng-container matColumnDef="ForageDetailTrace">
          <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
          <td mat-cell *matCellDef="let row">
            <a mat-stroked-button color="primary" [routerLink]="['/', 'expedition-trace', { DVL_SiteOrderID: row.SiteOrderID }]">
              <mat-icon>description</mat-icon>Voir les TRACES associées à cette commande
            </a>
          </td>
        </ng-container>

        <!--lien vers shipstation-->
        <ng-container matColumnDef="LienShipstation">
          <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
          <td mat-cell *matCellDef="let row">
            <a mat-stroked-button target="_blank" href="https://ship11.shipstation.com/orders/all-orders-search-result?quickSearch={{ row.SiteOrderID }}">
              <mat-icon>shopping_cart</mat-icon>Voir dans Shipstation
            </a>
          </td>
        </ng-container>

        <ng-container matColumnDef="LienChannelAdvisor">
          <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
          <td mat-cell *matCellDef="let row">
            <a
              mat-stroked-button
              target="_blank"
              href="https://complete.channeladvisor.com/Orders/OrderDetailV2.mvc?apid=12010161&invoiceId={{ row.CA_Order_ID }}"
            >
              <mat-icon>shopping_cart</mat-icon>Voir dans ChannelAdvisor
            </a>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="champsDisplay; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: champsDisplay" (click)="clickRow(row.id)"></tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="99">Aucun élément trouvé</td>
        </tr>
      </table>
    </div>
    <div class="listpage-footer">
      <div class="pagination-container" *ngIf="count != 0">
        Items par page:
        <mat-select
          appearance="inline"
          class="pagination-select"
          [(ngModel)]="rowPerPage"
          style="font-size: 8; width: 5em; padding-left: 10px"
          (selectionChange)="changeRowPerPage($event)"
        >
          <mat-option *ngFor="let count of rowPerPageSelect" [value]="count">{{ count }}</mat-option>
        </mat-select>
        <button mat-icon-button [disabled]="currentPage == 0" (click)="pagination('debut')">
          <mat-icon>first_page</mat-icon>
        </button>
        <button mat-icon-button [disabled]="currentPage == 0" (click)="pagination('precedent')">
          <mat-icon>navigate_before</mat-icon>
        </button>
        <div class="pagination-pages">{{ from }} à {{ to }} de {{ count }}</div>
        <button mat-icon-button [disabled]="to > count || count == 0" (click)="pagination('suivant')">
          <mat-icon>navigate_next</mat-icon>
        </button>
        <button mat-icon-button [disabled]="to > count || count == 0" (click)="pagination('fin')">
          <mat-icon>last_page</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <!--fin listpage-container -->

  <!--Mettre l'entité de FORM ici...-->
</div>
